import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "..";
import runningHttpClient from "../../axios";
import { StatisticTrainingCommonDomain } from "../../models/commonModels";

interface InitSt{
    data:StatisticTrainingCommonDomain|null
}

const initSt:InitSt ={
    data:null
}

const StatisticSLice = createSlice({
    name:"StatisticSLice",
    initialState:initSt,
    reducers:{
        fetchStatisticMain(state, action:PayloadAction<StatisticTrainingCommonDomain>){
            state.data=action.payload
        }
    }
})

export const {
    fetchStatisticMain
}=StatisticSLice.actions

export default StatisticSLice.reducer

export const getStatisticMain = () => async (dispatch:AppDispatch)=> {
    try{
        const result = await runningHttpClient.get<StatisticTrainingCommonDomain>("api/v1/statistics/main")
        dispatch(fetchStatisticMain(result.data))
    }catch(e){

    }finally{

    }
}

